import React, { Component } from 'react';
import AwardsComponent from './../components/awards';
// import * as api from '../api'

export default class OuterGetAward extends Component {
  constructor(props) {
    super (props)
    this.state = {
      isShow: false,
      awardsDom: null,
      curAwardInfo: {
        rateVal: '',
        nextornow: {},
        rewardInfo: {}
      }
    }
  }

  componentWillMount() {
    let info = JSON.parse(sessionStorage.getItem('yqs_curGame_awardInfo'))
    let awardInfo = Object.assign({}, {
      rateVal: info.globalfight,
      nextornow: info.nextornow,
      rewardInfo: info.reward
    })
    this.setState({awardsDom: <AwardsComponent rateVal={info.globalfight}/>, curAwardInfo: awardInfo})
  }

  _handleCloseDialog(){
    console.log('_handleCloseDialog:::')
  }

  _handle2JRApp() {
    window.location.href = `https://m.jr.jd.com/spe/downloadApp/index.html?id=1192&activityid=1158`
  }

  _handleSeeAward() {
    let { rewardInfo } = this.state.curAwardInfo
    window.location.href = `${rewardInfo.rewardURL}`
  }

  render() {
    let { rewardInfo } = this.state.curAwardInfo
    return (
      <div className='main_info'>
        {this.state.awardsDom}
        <div className='award_info'>
          <p className='tip'>本场获得奖励</p>
          <p className='award'>
            <span>{rewardInfo.rewardName}</span>
          </p>
        </div>
        <div className='btn yellow' onClick={this._handle2JRApp.bind(this)} clstag="jr|keycount|yqsbhby|24">去京东金融APP提现</div>
      </div>
    )
  }
}